import { Dispatch } from 'redux';
import { LogLevelFilterActionsCreatorsTypes } from 'containers/LogPage/store/actions/logPage.actions';
import { TimeFilterProps } from 'hooks/useDateTimeFilter';
import { Pagination } from 'models/Pagination';
import { IntegrationConfigService } from 'services/IntegrationConfig.service';
import { AppStates } from 'store';

export const changeDatetimeFilter = (dates: TimeFilterProps) => async (dispatch: Dispatch) => {
  dispatch(LogLevelFilterActionsCreatorsTypes.changeDatetimeFilter(dates));
};

export const changeLogLevelFilter = (logLevels: string[]) => async (dispatch: Dispatch) => {
  dispatch(LogLevelFilterActionsCreatorsTypes.changeLogLevelFilter(logLevels));
};

export const changeProviderFilter = (provider?: string) => async (dispatch: Dispatch) => {
  if (provider) dispatch(LogLevelFilterActionsCreatorsTypes.changeProviderFilter(provider));
};

export const changePageFilter = (actualPage?: number) => async (dispatch: Dispatch) => {
  if (actualPage) dispatch(LogLevelFilterActionsCreatorsTypes.changePageFilter(actualPage));
};

export const searchLogs =
  (integratorType: string, levels: string[], dates: TimeFilterProps, pagination: Pagination) =>
    async (dispatch: Dispatch, getState: () => AppStates) => {
      const {
        providersConfig: {
          organization: { orgId = '' },
        },
      } = getState();
      dispatch(LogLevelFilterActionsCreatorsTypes.searchLogs());
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const response: any = await IntegrationConfigService.searchLogs(orgId, integratorType, levels, dates, pagination);
        const { data, ...paginationInfo } = response;
        dispatch(LogLevelFilterActionsCreatorsTypes.searchLogsSuccess(data, paginationInfo));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        dispatch(LogLevelFilterActionsCreatorsTypes.searchLogsError(error.message));
      }
    };
